import { PersonRelationType } from '@dealstack/shared/lib/generated';

export enum ADD_RELATED_PERSON_FORM_FIELDS {
	email = 'email',
	first_name = 'first_name',
	last_name = 'last_name',
	relation_type = 'relation_type',
	custom_relation_type = 'custom_relation_type',
}

export interface AddRelatedPersonFormValues {
	[ADD_RELATED_PERSON_FORM_FIELDS.email]: string;
	[ADD_RELATED_PERSON_FORM_FIELDS.first_name]?: string;
	[ADD_RELATED_PERSON_FORM_FIELDS.last_name]?: string;
	[ADD_RELATED_PERSON_FORM_FIELDS.relation_type]: PersonRelationType;
	/** Free-text role; only used when relation_type is OTHER. */
	[ADD_RELATED_PERSON_FORM_FIELDS.custom_relation_type]?: string;
}
